function questionLinkDirective($compile) {
    'ngInject';

    return {
        transclude: false,
        restrict: 'A',
        scope: true,
        link(scope, element, attrs) {
            const id = parseInt(attrs.bbQuestionLink);
            scope.$watch('question_set', (newval, oldval) => {
                if (newval) {
                    return (() => {
                        const result = [];
                        for (const q of Array.from(scope.question_set)) {
                            let item;
                            if (q.id === id) {
                                scope.question = q;
                                element.attr('ng-model', 'question.answer');
                                element.attr('bb-question-link', null);
                                item = $compile(element)(scope);
                            }
                            result.push(item);
                        }
                        return result;
                    })();
                }
            });
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbQuestionLink', questionLinkDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-inputs/question-link/question_link.directive.js